<template>
  <div class="error-container h-100 d-flex align-items-center justify-center">
    <img class="error-img" src="../../assets/icons/error.svg" />
  </div>
</template>
<script>
export default {
}
</script>
<style scoped>
.error-img{
  height: 50px;
  width: 50px;
}
@media screen and (max-width: 1420px){
  /*#random_cards .error-img {*/
  /*  width: 250px !important;*/
  /*  height: 250px !important;*/
  /*}*/
}
</style>
